import React from "react";
import { AppBar, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import donor from "../../images/donor.jpeg";
import useStyles from "./styles";
import social from "../../images/social activist.jpeg";

const Option = () => {
  const classes = useStyles();
  return (
    <Grid>
      <AppBar className={classes.appBar} position="static" color="inherit">
        <Link to="/posts" className={classes.brandContainer}>
          <img src={donor} alt="Donor" height="250px" />
        </Link>
        <br />

        <Link to="/social" className={classes.brandContainer}>
          <img src={social} alt="Social Activist" height="300px" />
        </Link>
      </AppBar>
    </Grid>
  );
};

export default Option;
